import { autoinject } from 'aurelia-framework';
import { DashboardBaseView } from 'General/Views/Dynamic/Dashboard/DashboardBaseView';

@autoinject
export class DashboardView extends DashboardBaseView { }